import React from "react";
import { Form } from "react-bootstrap";

// Tem o formato de um input do tipo text mas só permite número
// Isso porque o input tipo number possui setinhas para cima e para baixo, não desejadas para alguns usos
const TextInputSpecialNumberFormik = ({ formik, field, maxLength, placeholder, evento, disabled }) => {
  const handleNumberInput = (e) => {
    // Permite apenas números
    const value = e.target.value.replace(/[^0-9]/g, "");
    formik.setFieldValue(field, value);
  };

  return (
    <>
      <Form.Control
        id={field}
        name={field}
        maxLength={maxLength}
        type="text"
        disabled={formik.isSubmitting || disabled}
        value={formik.values[field]}
        placeholder={placeholder}
        onChange={handleNumberInput}
        onBlur={evento}
        isInvalid={formik.touched[field] && formik.errors[field]}
        autoComplete="off"
      />
      {(formik.touched[field] || formik.dirty) && formik.errors[field] && (
        <Form.Control.Feedback type="invalid">{formik.errors[field]}</Form.Control.Feedback>
      )}
    </>
  );
};

export default TextInputSpecialNumberFormik;
